import React, { useState, useEffect } from 'react'
import { Form, Typography, Result } from 'antd'
//Hooks
import { useTranslation } from 'react-i18next'
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useFormLayout } from './../../Utils/Hooks/useFormLayout'

import ExternalLogins from './../login/ExternalLogins';

const { Title } = Typography;
const size = "large"

export default function SsoConnectPage({token:propsToken}) {
    const layout = useFormLayout(size, "vertical");
    const { t } = useTranslation(['login'])

    const [isLoading, setIsLoading] = useState(true);
    const [isResultSuccess, setIsResultSucces] = useState(false);

    const [doFetch] = useFetch();

    useEffect(() => {
        var uri_enc = encodeURIComponent(propsToken);
        doFetch("/Email/ValidateSSOToken?token=" + uri_enc)
            .then((response) => onValidatedLoaded(response.isSuccess))

        function onValidatedLoaded(isSuccess) {
            if(isSuccess){
                setIsResultSucces(true)
            }
            setIsLoading(false)  
        }

    }, // eslint-disable-next-line 
    [])

    if(isLoading) {
        return <p>Loading...</p>
    }

    if(!isResultSuccess)
    {
        return (
            <Result
                status={500}
                title={t("error.defaultErrorId")}
                subTitle={t("error.defaultErrorDescription")}
            />
        )
    }

    return (
        <div style={{ paddingBottom: 24 }}>
            <Title level={1} >{"Connect User to SSO"}</Title>
            <Form
                {...layout}
                name="basic"
            >
                <ExternalLogins
                    returnUrl=""
                    token={propsToken}
                />
            </Form>
        </div>
    );
}